export default "__VITE_ASSET__Cn5kMKuj__"